// Note: this script is init in PHP template

const { $ } = window;

window.YP.DalenysPaymentManager = function DalenysPaymentManager() {
    const paymentForm = $('#payment-form');
    const freePaymentForm = $('#free-payment-form');
    const paymentTypeChoice = $('input[name="paymentForm[payment_method_choice]"]');
    let alreadySubmitted = false;
    let hfields = null;

    const PAYMENT_METHOD_CB = 'CREDIT_CARD';
    const PAYMENT_METHOD_DELAYED = 'DELAYED';

    return {
        init() {
            if (paymentForm.length > 0) {
                // Sélectionner par défaut la première option de paiement
                paymentTypeChoice.first().prop('checked', true);
                paymentTypeChoice.first().trigger('change');
                this.initPaymentForm();
                this.handlePaymentFormSubmit();
                // Le bouton est rendu disabled côté serveur : activé une fois l'interception attachée
                paymentForm.find('.submit-button').removeAttr('disabled');
            }
            if (freePaymentForm.length > 0) {
                this.initFreePaymentForm();
            }
        },
        initPaymentForm() {
            const style = {
                input: {
                    'font-size': '16px',
                    color: '#171717',
                    'line-height': '45px',
                    'background-color': 'transparent',
                },
            };
            hfields = window.dalenys.hostedFields({
                key: {
                    id: $('.cb-form').data('api-key-id'),
                    value: $('.cb-form').data('api-key'),
                },
                fields: {
                    brand: {
                        id: 'brand-container',
                        version: 2,
                        useInlineSelection: true,
                        isCbPreferredNetwork: true,
                    },
                    card: {
                        id: 'card-container',
                        style,
                        enableAutospacing: true,
                    },
                    expiry: {
                        id: 'expiry-container',
                        style,

                    },
                    cryptogram: {
                        id: 'cvv-container',
                        style,
                        onFocus() {
                            $('.ccv-info').show();
                        },
                        onBlur() {
                            $('.ccv-info').hide();
                        },
                    },
                },
            });
            hfields.load();
        },
        handlePaymentFormSubmit() {
            paymentForm.on('submit', function handlePaymentFormSubmit(e) {
                const theForm = this;
                e.preventDefault();

                if (alreadySubmitted) {
                    return e.preventDefault();
                }
                alreadySubmitted = true;
                const btn = $(this).find('.c-btn');
                const oldVal = btn.val();
                btn.addClass('c-btn--loading');
                btn.attr('disabled', 'disabled');

                switch (paymentTypeChoice.filter(':checked').val()) {
                    case PAYMENT_METHOD_CB:
                        hfields.createToken((result) => {
                            if (result.execCode === '0000') {
                                document.getElementById('paymentForm_Cb_hf_token').value = result.hfToken;
                                document.getElementById('paymentForm_Cb_card_code').value = result.cardCode;
                                document.getElementById('paymentForm_Cb_card_expiry_date').value = result.cardValidityDate;
                                document.getElementById('paymentForm_Cb_card_type').value = result.cardType;
                                document.getElementById('paymentForm_Cb_card_selected_brand').value = result.selectedBrand;
                                theForm.submit();
                                return true;
                            }
                            btn.removeClass('c-btn--loading');
                            btn.removeAttr('disabled');
                            btn.text(oldVal);
                            alreadySubmitted = false;
                            return false;
                        });
                        break;

                    // case PAYMENT_TYPE_ALMA:
                    //     const almaPaymentUrl = $('#alma-in-page').data('payment-url');
                    //     const formData = new FormData(theForm);
                    //     theForm.action = almaPaymentUrl;
                    //     fetch(almaPaymentUrl, {
                    //         method: 'POST',
                    //         body: formData,
                    //     })
                    //         .then((response) => response.json())
                    //         .then((data) => {
                    //             if (data.success) {
                    //                 inPage.startPayment({ paymentId: data.paymentId });
                    //             } else {
                    //                 btn.removeClass('c-btn--loading');
                    //                 btn.removeAttr('disabled');
                    //                 btn.text(oldVal);
                    //                 alreadySubmitted = false;
                    //                 alert('Une erreur est survenue lors de l\'initialisation du paiement. Veuillez réessayer.');
                    //             }
                    //         })
                    //         .catch((err) => {
                    //             debugger;
                    //             btn.removeClass('c-btn--loading');
                    //             btn.removeAttr('disabled');
                    //             btn.text(oldVal);
                    //             alreadySubmitted = false;
                    //             alert('Une erreur est survenue lors de la communication avec le serveur. Veuillez réessayer.');
                    //         });
                    //     break;
                    case PAYMENT_METHOD_DELAYED:
                        theForm.submit();
                        break;
                    default:
                        alert('Moyen de paiement non autorisé');
                        break;
                }
                return false;
            });
            
        },
        initFreePaymentForm() {
            if (freePaymentForm.length > 0) {
                const confirmButton = freePaymentForm.find('.c-btn');
                confirmButton.on('click', function(e) {
                    if ($(this).prop('disabled')) {
                        e.preventDefault();
                        return false;
                    }
                    $(this).addClass('c-btn--loading');
                    $(this).attr('disabled', 'disabled');
                });
            }
        },
    };
};
